import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const UserWalletStatement = ()=>{
    const [userWalletStatement, setUserWalletStatement] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`userWalletStatement?page=${page}`);
            setUserWalletStatement(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`userWalletStatement/${id}`);
            setUserWalletStatement(userWalletStatement.filter((userWalletStatement) => userWalletStatement.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'User Wallet Statement'}>
            <InnerNav createLink={'/userWalletStatementCreate'} listLink={'/userWalletStatement'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Date </th>
                                    <th className="px-4 py-3">User </th>
                                    <th className="px-4 py-3">Deposit </th>
                                    <th className="px-4 py-3">Withdrawal </th>
                                    <th className="px-4 py-3">TrxCode </th>
                                    <th className="px-4 py-3">Fee </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {userWalletStatement.map((userWalletStatement)=>{
                                         return(
                                             <tr key={userWalletStatement.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{userWalletStatement.id}</td>
                                                 <td className="px-4 py-3 text-sm">{userWalletStatement.date}</td>
                                                 <td className="px-4 py-3 text-sm">{userWalletStatement.user}</td>
                                                 <td className="px-4 py-3 text-sm">{userWalletStatement.deposit}</td>
                                                 <td className="px-4 py-3 text-sm">{userWalletStatement.withdrawal}</td>
                                                 <td className="px-4 py-3 text-sm">{userWalletStatement.trx_code}</td>
                                                 <td className="px-4 py-3 text-sm">{userWalletStatement.fee}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/userWalletStatement/${userWalletStatement.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(userWalletStatement.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default UserWalletStatement;